export function easeIn(t: number, power: number): number {
  return t ** power;
}

export function easeOut(t: number, power: number): number {
  return 1 - (t * -1 + 1) ** power;
}

export function easeInOut(t: number, power: number): number {
  return t < 0.5
    ? t ** power * 2 ** (power - 1)
    : 1 - (t * -2 + 2) ** power / 2;
}
